import api from "Common/Client/Interceptor";

export const login = async (email, password) => {
  try {
    console.log(" Login attempt for:", email);
    
    const response = await api.post(
      "/Account/Login",
      { 
        email: email.trim(),
        password: password 
      },
      {
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
      }
    );
    
    console.log(" Login successful");
    return response.data;
  } catch (error) {
    console.error(" Login API Error:", error.response?.data);
    
  
    throw error;
  }
};

export const requestPasswordReset = async (email) => {
  const response = await api.post("/Account/forget-password/request", {
    email: email.trim(),
  });
  return response.data;
};

export const confirmPasswordReset = async (token, password) => {
  const response = await api.post("/Account/forget-password/confirm", {
    token,
    password,
  });
  return response.data;
};